import React, { FC } from "react";
import { CardContentProps } from "@material-ui/core/CardContent";
import { StyledMuiCardContent } from './styles';

const CardContent: FC<CardContentProps> = (props) => {
  return (
    <StyledMuiCardContent {...props} />
  );
};

export default CardContent;
